import {AbstractSearchControlComponent} from "../abstract-search-control.component";
import {
    AfterContentInit,
    ChangeDetectorRef,
    ContentChild,
    Directive,
    EventEmitter,
    Injector,
    Input,
    OnDestroy,
    Output,
    ViewChild
} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {forkJoin, map, Subscription} from "rxjs";
import {SelectOptionsComponent} from "../../../select/options/select-options.component";
import {SearchPageService} from "../../search-page/search-page.service";
import {AbstractSelectControlComponent, SelectControlSelector} from "../../../select/abstract-select-control.component";
import {SearchControlSelectObject, SearchControlSelectObjects} from "../../../select/search-control-select-objects";
import {SearchModel} from "@fedeltapointofsale/data-client";

@Directive()
export class AbstractSelectSearchControlComponent<T extends SearchModel<any>> extends AbstractSearchControlComponent implements AfterContentInit, OnDestroy {
    @Input() objectValue: any;
    @Input() isMulti: boolean;
    @Input() multiObjectValueType: boolean;
    @Input() clearSelectionOptionLabel: string;
    @Input() allowClearSelectionOption: boolean = true;
    @Input() initialDefaultValue: any;
    @Input() notifyInitialDefault: boolean = false;

    @Output() onSelect: EventEmitter<any> = new EventEmitter();

    @ContentChild(SelectOptionsComponent) selectOptionsComponent: SelectOptionsComponent;
    @ViewChild(SelectControlSelector, {static: true}) selectControlComponent: AbstractSelectControlComponent;

    extendedSearchComponent: any;
    extendedEditComponent: any;

    searchPageService: SearchPageService;
    translateService: TranslateService;
    changeDetectorRef: ChangeDetectorRef;

    data: Array<any> = [];
    valueField: string;
    labelField: string;
    labelSearchField: string;

    summaryLabelField: string;

    private subscriptions: Subscription = new Subscription();

    constructor(protected model: T, injector: Injector, valueField: string = "value", labelField: string = "label") {
        super();
        this.searchPageService = injector.get(SearchPageService, null);
        this.translateService = injector.get(TranslateService, null);
        this.changeDetectorRef = injector.get(ChangeDetectorRef, null);
        this.valueField = valueField;
        this.labelField = labelField;
    }

    ngAfterContentInit(): void {
        if (this.selectOptionsComponent) {
            this.subscriptions.add(this.selectOptionsComponent.data$.subscribe(data => {
                this.data = data;
                this.changeDetectorRef.detectChanges();
            }));
        }

        if (this.searchPageService) {
            this.subscriptions.add(this.searchPageService.pageRefreshed.subscribe(() => {
                if (this.selectOptionsComponent) {
                    this.selectOptionsComponent.refreshData();
                } else if (this.selectControlComponent) {
                    this.selectControlComponent.refreshData();
                }
            }));
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    buildData(options: { label: string, value?: any }[]): void {
        forkJoin(
            options.map(option =>
                this.translateService.get(option.label).pipe(
                    map(translation => ({
                        [this.labelField]: translation,
                        [this.valueField]: option.value === undefined ? translation : option.value
                    }))
                )
            )
        ).subscribe(results => this.data = results);
    }

    onDataLoaded(data: Array<any>): void {
    }

    override setSearchControlSelectObjects(searchControlSelectObjects: SearchControlSelectObjects): void {
        // Use labels from data as names
        searchControlSelectObjects.objects.forEach((searchControlSelectObject: SearchControlSelectObject) => {
            const label: string = this.getLabelForValue(searchControlSelectObject.id);
            if (label !== undefined) {
                searchControlSelectObject.name = label;
            }
        });

        this.selectControlComponent.setSearchControlSelectObjects(searchControlSelectObjects);
    }

    getLabelForValue(value: any): string {
        const datum: any = this.data.find((d: any) => d[this.valueField] === value);
        return datum ? datum[this.labelField] : undefined;
    }
}
